// import { Footer } from "../components/blocks/Footer";
import { useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import ArgoneLogo from "../logo.svg";
// import { useDispatch } from "react-redux";
// import { addUser } from "../services/reducers";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import FontAwesome icons
import Swal from "sweetalert2";
import { ResetAdminPassword } from "../utils/Api/ApiCalls";
import { ClipLoader } from "react-spinners";

const ResetPassword = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const adminid = params.get("adminid");

  const Navigate = useNavigate();
  // const dispatch = useDispatch();
  const [load, setLoading] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // State to manage password visibility
  const [formData, setFormData] = useState({
    password: "",
  });

  const onChangeForm = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const LoginUserSubmit = async () => {
    if (formData.password !== confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "password didn't match",
        timer: 2000,
        showConfirmButton: false,
      });
    } else {
      setLoading(true);
      try {
        const res = await ResetAdminPassword(adminid, formData);
        
        if (res) {
          Swal.fire({
            icon: "success",
            title: "password chnaged successfull",
            timer: 2000,
            showConfirmButton: false,
          });
          Navigate("/login");
        }

        // Navigate("/");
        setLoading(false);
        //   dispatch(addUser(res?.data?.data?.info));
      } catch (err) {
        setLoading(false);
        return err;
      }
    }
  };
  return (
    <main className="main pages">
      <div className="page-content pt-150 pb-150">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 m-auto">
              <div className="row">
                <div>
                  <div className="card">
                    <div className="card-header">
                      <p>
                        <img src={ArgoneLogo} alt="Argone-logo" />
                      </p>
                      <h5>Reset Password</h5>
                    </div>
                    <div className="card-body">
                      <p style={{ marginBottom: "20px" }}>
                        create a new Password?{" "}
                      </p>
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          LoginUserSubmit();
                        }}
                        name="enq"
                      >
                        <div className="row">
                          <div className="form-group col-md-12">
                            <label>
                              New Password <span className="required">*</span>
                            </label>
                            <div className="input-group">
                              <input
                                required=""
                                className="form-control"
                                name="password"
                                type={showPassword ? "text" : "password"}
                                onChange={onChangeForm}
                              />
                              <span
                                className="input-group-text"
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                  cursor: "pointer",
                                  border: "1px solid #ececec",
                                  backgroundColor: "#fff",
                                  boxShadow: "none",
                                }}
                              >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                              </span>
                            </div>
                          </div>
                          <div className="form-group col-md-12">
                            <label>
                              Confirm Password{" "}
                              <span className="required">*</span>
                            </label>
                            <div className="input-group">
                              <input
                                required=""
                                className="form-control"
                                name="confirm"
                                type={showPassword ? "text" : "password"}
                                onChange={(e) => {
                                  setConfirmPassword(e.target.value);
                                }}
                              />
                              <span
                                className="input-group-text"
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                  cursor: "pointer",
                                  border: "1px solid #ececec",
                                  backgroundColor: "#fff",
                                  boxShadow: "none",
                                }}
                              >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                              </span>
                            </div>
                          </div>

                          {load ? (
                            <div style={{ marginTop: "20px" }} class="mb-4">
                              <button
                                disabled
                                type="submit"
                                class="btn btn-primary w-100"
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    // justifyContent: "space-between",
                                    justifyContent: "center",
                                    width: "100%",
                                    alignItems: "center",
                                  }}
                                >
                                  <div>Loading... </div>
                                  <span>
                                    <ClipLoader color="white" size={15} />
                                  </span>
                                </div>
                              </button>
                            </div>
                          ) : (
                            <div style={{ marginTop: "20px" }} class="mb-4">
                              <button
                                type="submit"
                                class="btn btn-primary w-100"
                                style={{
                                  display: "flex",
                                  // justifyContent: "space-between",
                                  justifyContent: "center",
                                  width: "100%",
                                  alignItems: "center",
                                }}
                              >
                                Submit
                              </button>
                            </div>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </main>
  );
};

export default ResetPassword;
